import { useState } from "react";

const message = [
  "Learn React *", "Apply for Jobs", "Invest your new income💢", "Thank You"
];

export default function App (){
  const [step , setStep] = useState(1)
  const [isOpen, setIsOpen] = useState(true)




  function handlePrevious (){
    if(step > 1) setStep((s) => s - 1)
  }

  function handleNext (){
   if(step < 4) setStep((s) => s + 1 )
  }

  function switchButton(){
    setIsOpen((s) => s = !isOpen)
  }

  
  return (
    <>

      <button className="close" onClick={switchButton}>&times;</button>

      {isOpen && 
        <div className="steps">
          <div className="numbers">
            <div className={`${step >= 1 ? "active" : ""}`}>1</div>
            <div className={`${step >= 2 ? "active" : ""}`}>2</div>
            <div className={`${step >= 3 ? "active" : ""}`}>3</div>
            <div className={`${step >= 4 ? "active" : ""}`}>4</div>
          </div>

          <p className="message">
            Step {step}: {message[step - 1]}
          </p>

          <div className="buttons">
            <button
              style={{ backgroundColor: "#7950f2", color: "#fff" }}
              onClick={handlePrevious}
            >
              Previous
            </button>
            <button
              style={{ backgroundColor: "#7950f2", color: "#fff" }}
              onClick={handleNext}
            >
              Next
            </button>
          </div>
        </div>
      }
    </>
  );
}